import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import BottomBar from './BottomBar';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex flex-col min-h-screen bg-[#e6f7f5]">
      <Header />
      {/* Spacer for top bar (40px) + header (64px mobile / 72px desktop) */}
      <div className="h-[104px] lg:h-[112px]" aria-hidden="true"></div>
      <main className="flex-1" role="main">
        {children}
      </main>
      <Footer />
      <BottomBar />
    </div>
  );
}